"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredLabel = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var LABEL = {
    required: '必須',
    optional: '任意',
};
var StyledRequiredLabel = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 32px;\n  font-size: 12px;\n  font-weight: bold;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  padding: 4px 4px;\n  line-height: 1;\n  background-color: ", ";\n  border-radius: 4px;\n"], ["\n  width: 32px;\n  font-size: 12px;\n  font-weight: bold;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  padding: 4px 4px;\n  line-height: 1;\n  background-color: ", ";\n  border-radius: 4px;\n"])), function (props) {
    return props.required ? styles_1.COLOR.background.attention : styles_1.COLOR.background.optional;
});
var RequiredLabel = function (_a) {
    var required = _a.required;
    var label = required ? LABEL.required : LABEL.optional;
    return react_1.default.createElement(StyledRequiredLabel, { required: required }, label);
};
exports.RequiredLabel = RequiredLabel;
var templateObject_1;
